import React, { Component } from 'react'
import type { Node } from 'react'
import { Helmet } from 'react-helmet'

type Props =  {
  title: string,
  description: string,
  children: Node
}

class Page extends Component<Props> {
  render() {
    const {
      title,
      description,
      children
    } = this.props

    return (
      <div className='pa2'>
        <Helmet>
          <title>{title}</title>
          <meta
            name='description'
            content={description}
          />
        </Helmet>

        {children}
      </div>
    )
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/Page.js